export const SET_AUTH = "SET_AUTH";
export const SIGN_IN_USER = "SIGN_IN_USER";
export const SIGN_OUT_USER = "SIGN_OUT_USER";
export const UPDATE_AUTH_USER = "UPDATE_AUTH_USER";
